module.exports = __webpack_public_path__ + "shared-facebook.svg?42b40900945cb7a5d28c52a5810f2e88";